export enum StepStatus {
    COMPLETE = 'complete',
    ERROR = 'error',
    IN_PROGRESS = 'in-progress',
    NOT_STARTED = 'not-started',
    FUNDED = 'funded',
}
